import type { AlertSourcesType } from '@/api/types/Alert'

interface AlertSourceType {
  value: AlertSourcesType
  label: string
  baseUrl: string
}

const filtersBySource: Record<AlertSourcesType, string[]> = {
  GOOGLE: ['peek_pws=0', 'nfpr=1', 'tbs=qdr:d30'],
  GOOGLE_IMAGES: ['peek_pws=0', 'nfpr=1', 'tbs=qdr:d30'],
  YOUTUBE: ['sp=EgIIBA%253D%253D'],
  GO_FUND_ME: ['time-period=30'],
}

export const AlertSourceConfigs: Record<AlertSourcesType, AlertSourceType> = {
  GOOGLE: {
    value: 'GOOGLE',
    label: 'Google Search',
    baseUrl: 'https://www.google.com/search?' + filtersBySource.GOOGLE.map(f => f + '&').join('') + 'q=',
  },
  GOOGLE_IMAGES: {
    value: 'GOOGLE_IMAGES',
    label: 'Google Images',
    baseUrl: 'https://www.google.com/images?' + filtersBySource.GOOGLE_IMAGES.map(f => f + '&').join('') + 'q=',
  },
  YOUTUBE: {
    value: 'YOUTUBE',
    label: 'YouTube',
    baseUrl: 'https://www.youtube.com/results?' + filtersBySource.YOUTUBE.map(f => f + '&').join('') + 'search_query=',
  },
  GO_FUND_ME: {
    value: 'GO_FUND_ME',
    label: 'GoFundMe',
    baseUrl: 'https://www.gofundme.com/s?' + filtersBySource.GO_FUND_ME.map(f => f + '&').join('') + 'q=',
  },
}

export const searchAliasInSource = (
  alias: string,
  source: AlertSourcesType
): void => {
  const url = AlertSourceConfigs[source].baseUrl + encodeURIComponent(`"${alias}"`)
  window.open(url, '_blank')
}
